const { default: BrowseFormRoute } = require("./BrowseForm/BrowseFormRoute");

export default { BrowseFormRoute }